import { render } from "./StudentInfo.vue?vue&type=template&id=705fc5a0&scoped=true"
import script from "./StudentInfo.vue?vue&type=script&lang=js"
export * from "./StudentInfo.vue?vue&type=script&lang=js"

import "./StudentInfo.vue?vue&type=style&index=0&id=705fc5a0&lang=less&scoped=true"

import exportComponent from "/Users/zhangmohan/work/activitymarketing-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705fc5a0"]])

export default __exports__